<script>
  import { page } from "@inertiajs/svelte";
  import { success, danger } from "../Components/Toasties/notifier";

  // Handle flash messages from the backend
  $: flash = $page.props.flash;

  $: {
    if (flash?.notice) success(flash.notice);
    if (flash?.error) danger(flash.error);
  }
</script>

<svelte:head>
  <title>Pillar - Audit Board</title>
  <link
    href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100&display=swap"
    rel="stylesheet"
  />
</svelte:head>

<!-- Minimal layout wrapper for embedded views -->
<div class="embed-layout h-full overflow-auto bg-gray-100">
  <slot />
</div>

<style>
  /* Global styles for embedded view */
  :global(html), :global(body) {
    @apply h-full;
    font-family: "Poppins", sans-serif;
    margin: 0;
    padding: 0;
  }
  
  /* Remove any default margins/padding that might interfere with embedding */
  :global(*) {
    box-sizing: border-box;
  }
  
  /* Ensure the layout takes full height */
  .embed-layout {
    position: relative;
    width: 100%;
    min-height: 100vh;
  }
</style>